export interface TransferRecurrences {
  ONE_TIME: string
  RECURRING: string
}
export type TransferRecurrenceType = keyof TransferRecurrences
export const TransferRecurrenceText = {
  ONE_TIME: 'One time transfer',
  RECURRING: 'Recurring transfer'
}

export interface WhenToSend {
  IMMEDIATELY: string
  IN_THE_FUTURE: string
}
export type WhenToSendType = keyof WhenToSend
export const WhenToSendText = {
  IMMEDIATELY: 'Immediately',
  IN_THE_FUTURE: 'In the future'
}

export interface TransferFrequency {
  WEEKLY: string
  EVERY_OTHER_WEEK: string
  MONTHLY: string
  EVERY_3_MONTHS: string
  EVERY_6_MONTHS: string
  ANNUALLY: string
}
export type TransferFrequencyType = keyof TransferFrequency
export const TransferFrequencyText = {
  WEEKLY: 'Weekly',
  EVERY_OTHER_WEEK: 'Every Other Week',
  MONTHLY: 'Monthly',
  EVERY_3_MONTHS: 'Every 3 Months',
  EVERY_6_MONTHS: 'Every 6 Months',
  ANNUALLY: 'Annually'
}
export type WhenToSendUnion = 'IMMEDIATELY' | 'IN_THE_FUTURE'
export type RecurringTransferFrequency =
  | 'WEEKLY'
  | 'EVERY_OTHER_WEEK'
  | 'MONTHLY'
  | 'EVERY_3_MONTHS'
  | 'EVERY_6_MONTHS'
  | 'ANNUALLY'
export type RecurringFrequencyUnit = 'DAY' | 'WEEK' | 'MONTH'
export type TransferRecurrencesType = 'ONE_TIME' | 'RECURRING'
